<template>
  <div
    v-if="!navbarHidden"
    :class="{minimized: minimized}"
    class="sidebar h-100">
    <div>
      <ul class="nav flex-column">
        <li class="nav-link"> <router-link
          :to="{ name: 'Parameters'}"
          class="navbar-brand col-6"> Gestion des paramètres </router-link> </li>
        <li class="nav-link"> <router-link
          :to="{ name: 'RegularTasks'}"
          class="navbar-brand col-6">Gestion des tâches régulières</router-link> </li>
        <li class="nav-link"> <router-link
          :to="{ name: 'Projects'}"
          class="navbar-brand col-6">Gestion des projets</router-link> </li>
        <li class="nav-link"> <router-link
          :to="{ name: 'Workers'}"
          class="navbar-brand col-6">Gestion des individus</router-link> </li>
      </ul>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minimized: false,
    };
  },
  computed: {
    navbarHidden() {
      return !!this.$route.meta.hideNavbar;
    },
  },
  watch: {
    navbarHidden: {
      handler(newVal) {
        const [body] = window.document.getElementsByTagName('body');
        if (newVal) {
          body.classList.remove('sidebar-present');
        } else {
          body.classList.add('sidebar-present');
        }
      },
      immediate: true,
    },
  },
  methods: {
    expand() {
      this.minimized = false;
      const [body] = window.document.getElementsByTagName('body');
      body.classList.remove('sidebar-minimized');
    },
    collapse() {
      this.minimized = true;
      const [body] = window.document.getElementsByTagName('body');
      body.classList.add('sidebar-minimized');
    },
  },
};
</script>

<style lang="scss">
$expanded-width: 20rem;
$collapsed-width: 4.75rem;

body.sidebar-present {
  padding-left: $expanded-width;
  transition: padding-left ease 0.4s;

  &.sidebar-minimized {
    padding-left: $collapsed-width;
  }
}

.sidebar {
  position: fixed;
  top: $nav-link-height + ($navbar-padding-y * 2);
  bottom: 0; // 4.5rem;
  left: 0;
  width: $expanded-width;
  border-right: 1px solid $gray-500;
  background: $light;
  transition: width ease 0.4s;
  overflow-x: hidden;

  h3 {
    transition: height ease 0.4s;
    height: 33px;
    overflow: hidden;
  }

  .sidebar-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: $expanded-width;
    transition: width ease 0.4s;
    background: $light;
    border-top: 1px solid $gray-500;
    border-right: 1px solid $gray-500;

    .btn-toggle {
      border-radius: 0;
      background: $gray-400;
      border-color: $gray-400;

      i {
        font-size: $h4-font-size;
      }

      &:hover,
      &:focus {
        background: $gray-500;
      }
    }
  }

  &.minimized {
    &,
    .sidebar-footer {
      width: $collapsed-width;
    }

    h3 {
      height: 0;
    }
  }
}
</style>
